import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { user, ready, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (ready && user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-navy-900 flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-sm">
        <div className="text-center mb-12"><Logo variant="wordmark" className="h-10 mx-auto" /></div>
        <p className="text-center text-[11px] tracking-[0.3em] uppercase text-gold mb-10">Selection Team Access</p>
        <form onSubmit={submit} className="space-y-8">
          <div>
            <label className="block text-[10px] tracking-[0.25em] uppercase text-ivory/50 mb-2">Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" className="w-full bg-transparent border-b border-ivory/25 focus:border-gold outline-none py-3 text-ivory transition-colors" />
          </div>
          <div>
            <label className="block text-[10px] tracking-[0.25em] uppercase text-ivory/50 mb-2">Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" className="w-full bg-transparent border-b border-ivory/25 focus:border-gold outline-none py-3 text-ivory transition-colors" />
          </div>
          {error && <p className="text-red-300 text-sm" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-btn" className="w-full bg-ivory hover:bg-gold text-navy py-4 text-xs tracking-[0.25em] uppercase transition-colors duration-500 disabled:opacity-50 inline-flex items-center justify-center gap-2">
            {loading ? <><Loader2 size={15} className="animate-spin" /> Entering</> : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
